module.exports = __webpack_public_path__ + "img/uganda.6368fa8f.svg";